import React from 'react'
import PropTypes from 'prop-types'

import _ from 'lodash'

import { withStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'

import Batch from './Batch'
import Loading from '../loading/Loading'

const styles = theme => ({
  root: { display: 'flex', flexWrap: 'wrap', width: '100%', height: '100%' },
  paper: {
    position: 'absolute',
    top: 75, left: 10, right: 10, bottom: 10,
    textAlign: 'center',
    padding: theme.spacing.unit,
    paddingLeft: '10%',
    paddingRight: '10%'
  }
})

class Home extends React.Component {

  constructor() {
    super()
    this.state = {
      error: '',
      results: []
    }
  }

  componentWillMount() {
    const { handleRefreshProfile, profile } = this.props
    if (_.isEmpty(profile)) handleRefreshProfile()
  }

  render() {
    const { classes, handleLogout, isAuthenticated, isSetup, apiKey, clientId, profile } = this.props
    return (
      <div className={classes.root}>
        { (!isAuthenticated || _.isEmpty(profile)) && <Loading /> }
        { isAuthenticated && isSetup && profile &&
          <Batch
            apiKey={apiKey} 
            clientId={clientId}
            profile={profile}
          />
        }
        { isAuthenticated && !isSetup &&
          <div className={classes.root}>
            <Paper className={classes.paper} elevation={1}>
              <Typography variant='headline' style={{margin: 10}}>
                User Awaiting Setup
              </Typography>
              <Typography component='p' style={{margin: 20}}>
                No profile was found for your user account: if you have just signed up, we will contact you
                once your account is fully activated.  If you have received a confirmation email that your
                account has been set up please <a href='/' onClick={handleLogout}>click here to logout</a>.
                Once you log back in again you should have access to the application.  <br/><br/>If you still
                have questions please contact <a href='mailto:support@addresscloud.com'>support@addresscloud.com</a>
              </Typography>
            </Paper>
          </div>
        }
      </div>
    )
  }
}

Home.propTypes = {
  classes: PropTypes.object.isRequired,
  handleLogout: PropTypes.func.isRequired,
  handleRefreshProfile: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  isSetup: PropTypes.bool.isRequired,
  apiKey: PropTypes.string.isRequired,
  clientId: PropTypes.string.isRequired,
  profile: PropTypes.object.isRequired,
}

export default withStyles(styles)(Home)
